import React from 'react';
import Recaptcha from 'react-recaptcha';
import styleContact from './styleContact.scss';
import {Contact} from 'api';
import {Input, Textarea} from 'components/vitrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import CONFIG from 'base/constants/config';

class ContactForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      phone: '',
      email: '',
      content: '',
      isSubmit: false
    };
    this.props.validators['formContact'] = [];
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formContact'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {name, email, phone, content} = this.state;
      const data = {
        name: name,
        email: email,
        phone: phone,
        content: content,
        type: 0
      };
      if (this.props.businessId) {
        data.businessId = this.props.businessId;
        data.type = 2;
      }
      this.setState({isSubmit: true});
      Contact.actions.send.request({}, {data}).then(response => {
        this.setState({isSubmit: false});
        toastr.success('Thành công!', 'Đã gửi liên hệ thành công.');
        this.clearForm();
      }).catch(error => {
        toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
        this.setState({isSubmit: false});
      });
    }
  }

  clearForm() {
    this.setState({
      name: '',
      phone: '',
      email: '',
      content: '',
      isSubmit: false
    });
  }

  render() {
    const {name, email, phone, content, isSubmit} = this.state;
    return (
      <form className="contact-form-S" name="formContact" method="POST" onSubmit={this.onSubmit} noValidate>
        <Input type="text" placeholder="Tên..."
          className="contact-form-group"
          iconClassName="fa fa-user-o form-control-icon"
          name="name"
          value={name}
          required={true}
          onChange={this.onChange}
          bindValidator={this} channel="formContact"
          errorMessage="Tên không được để trống"/>
        <Input type="text" placeholder="Số điện thoại..."
          className="contact-form-group"
          iconClassName="fa fa-phone form-control-icon"
          name="phone"
          value={phone}
          required={true}
          onChange={this.onChange}
          bindValidator={this} channel="formContact"
          errorMessage="Số điện thoại không được để trống"/>
        <Input type="text" placeholder="Email"
          className="contact-form-group"
          iconClassName="fa fa-at form-control-icon"
          name="email"
          value={email}
          required={true}
          onChange={this.onChange}
          bindValidator={this} channel="formContact"
          errorMessage="Email không được để trống"/>
        <Textarea type="text" placeholder="Nội dung yêu cầu..."
          className="contact-form-group"
          inputClassName="form-control-areal"
          required={true}
          name="content"
          value={content}
          onChange={this.onChange}
          bindValidator={this} channel="formContact"
          errorMessage="Bạn vui lòng nhập mô tả ngắn"/>
        <div className="google-captcha">
          <Recaptcha sitekey={CONFIG.CAPTCHA_KEY}/>
        </div>
        <div className='contact-form-btn-wrap'>
          <LaddaButton className="contact-form-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi</LaddaButton>
        </div>
      </form>
    );
  }
}

ContactForm.defaultProps = {
  validators: {}
};

export default ContactForm;



// WEBPACK FOOTER //
// ./components/contact/ContactForm.jsx